import React, { useState, useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import { Carousel } from 'react-bootstrap';
import axios from 'axios';

import Footer from "../components/Footer";
import ComponentToPrint from "../components/ComponentToPrint";
import CollectionMaininfoPageCell from "../components/CollectionMaininfoPageCell";
import { apiUrl, AND, OR, NOT, images } from '../config';

import TFAILogoMain from '../assets/images/TFAI-logo-main.svg'
import ListUpBannerAll from '../assets/images/cnt-head-00.jpg'

const Detail = () => { 
    const [queryParams] = useSearchParams();
    const type = queryParams.get('type'); // 藏品類別
    const searchWord = localStorage.getItem('keyWord') // 查詢關鍵字
    const collectiblesId = localStorage.getItem('collectiblesId') // 查詢關鍵字
    const [headPic, setHeadPic] = useState(null); // 圖片    
    const [title, setTitle] = useState(null);     // 類別
    const printPageRef = useRef();
    const [urlType, setUrlType] = useState(null);
    const [dataDisplay, setDataDisplay] = useState(null); // 詳細資料呈現
    const [dataInfo, setDataInfo] = useState(null); // 圖檔資訊

    useEffect(() => {            
        const getDetailData = async () => {
            try {
                const response = await axios.get(apiUrl + '/detail', {
                    params: {
                        indexId: collectiblesId
                    }
                });
                setDataDisplay(response.data.dataDisplay);
                setDataInfo(response.data.dataInfoJson);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        getDetailData();
    }, []);

    useEffect(() => {
        for(const option of images){
            if(type===option.value){
              setTitle(option.label);
              setUrlType(option.urlType);
              if(option.imageData!=null){
                setHeadPic(`data:image/jpeg;base64,${option.imageData}`);
              }else{
                setHeadPic(ListUpBannerAll);
              }
            }
          }
    }, [type]);

    const wordArray = searchWord.split(new RegExp(`(${AND}|${OR}|${NOT})`, 'i'))
    let skipNext = false
    const searchArray = wordArray.filter((element) => {
        if (element === '' || element === AND || element === OR || skipNext) {
          skipNext = false;
          return false;
        } else if (element === NOT) {
          skipNext = true;
          return false;
        }
        return true;
    });

    // 判斷關鍵字是否需要添加 highlight 樣式
    const renderWithHighlight = (text) => {
        if (searchArray.length > 0 && text !== null) {
            const sortedArray = searchArray.sort((a, b) => b.length - a.length);
            const regex = new RegExp(sortedArray.join('|'), 'gi');
            // Matches array needed to maintain the correct letter casing
            const matches = [...text.matchAll(regex)];
            return text.split(regex).map((part, index) => (
              `${part}${index<matches.length ? `<div key={index} style="background-color: rgb(255, 255, 94); color: black; display: math;">${matches[index]}</div>` : ''}`
            )).join('');
        }
        return text   
    }

    const filmJSONlist = (colName, list) =>{
        if(colName==="演員表"){                                         
            return list.map((item, index) => (
                <div key={index+1} dangerouslySetInnerHTML={{ __html: renderWithHighlight((Object.keys(item)[0]===""?"":Object.keys(item)[0]+" ： ") + Object.values(item)[0]) }}/>
            ))
        }else if(colName==="職員表"){
            return list.map((item, index) => (
                <div key={index+1} dangerouslySetInnerHTML={{ __html: renderWithHighlight(Object.keys(item)[0]+" : "+Object.values(item)[0]) }}/>
            ))
        }
        return null
    }
    
    const createMedia=()=>{
        switch(urlType){
            case 1:                
                return (
                    <div>
                        <div>
                        {dataInfo && dataInfo.圖檔URL ?             
                            <div><img alt="rfurl" src={dataInfo.圖檔URL} style={{width:'100%',objectFit:'cover'}}></img></div>                
                        : null}
                        </div>                    
                        {dataInfo && conditionCheck(dataInfo.數位修復說明)?
                            <div className="CollectionMainInfoAreaPageVer">
                                <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                                    <div style={{margin: '5px', fontWeight: 'bolder'}}>
                                        <a href={dataInfo.數位修復說明}>{"數位修復說明"}</a>
                                    </div>
                                </div>
                            </div>     
                        :null}
                    </div>
                )                
            case 2:
                return (
                    <Carousel>
                    {dataInfo && dataInfo.圖檔URL ?    
                        getCarousel(dataInfo.圖檔URL)             
                        : null
                    }
                    </Carousel>
                )
            case 3:
                return (
                    <div>
                    {dataInfo && dataInfo.原始藏品編號 ?                        
                        <div>
                            <div>
                                <iframe title="dfsrc" style={{width:'100%',height:'300px'}}
                                    src={'https://vcenter.iis.sinica.edu.tw/videojs/watch_frame_for_digitalarchives.php?id='+dataInfo.原始藏品編號+'&fn='+dataInfo.原始藏品編號} allowFullScreen>
                                </iframe>
                            </div>
                            <div>{"#影片撥放需等候5~10秒載入，請耐心等候"}</div>
                        </div>
                        : null
                    }
                    </div>
                )
            default :
                return null
        }
    }
    const getCarousel=(url)=>{
        let arrayUrl = url.split('|')
        return (  
            arrayUrl.map(url=>{
                return(                     
                    <Carousel.Item>
                        <img alt="itemimg" src={url} style={{width:'100%',objectFit:'cover'}}></img>
                    </Carousel.Item>
                )
            })           
        )
    }
    const conditionCheck = (value)=>{        
        if(value){
            let target = value.replace(/\s/g,"")
            if(target === '' || target === '無標註'){
                return false
            } else{
                return true
            }
        } else{
            return false
        }
    }

    return (<>
        <div className="TFAI-box">
            <div id="content-bg">
                <aside></aside>
                <div className="ctn-pic"><img alt="headPic" src={headPic} /></div>
            </div>
            <div className="container-xl">
                <div className="ctn-header">
                    <div className="ctn-logo d-none d-lg-block">
                        <Link to="/"><img src={TFAILogoMain} alt="TFAI logo" className="img-fluid"/></Link>
                    </div>
                    <div className="ctn-heading">
                        <h1><span>{title}</span>藏品</h1>
                    </div>
                </div>
                <div className="ctn-area">
                    <div className="data-header row">  
                        <div className="col-12 col-md-7 col-lg-6">
                            {dataDisplay && <h2><div dangerouslySetInnerHTML={{ __html: renderWithHighlight(dataDisplay.title) }} /></h2>}
                        </div>
                        <div className="col-12 col-md-5 col-lg-4 d-flex align-items-end share-links">
                            <div className="media-share">        
                                <ReactToPrint
                                    trigger={()=>                         
                                        <svg className="bi bi-printer-fill" viewBox="0 0 16 16">
                                            <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"/>
                                            <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                                        </svg>
                                    }
                                    content={()=>printPageRef.current}
                                /> 
                                <div style={{ display: "none" }}><ComponentToPrint ref={printPageRef} type={type} dataDisplay={dataDisplay} searchWord={searchWord} dataInfo={dataInfo} urlType={urlType}/></div>                    
                            </div>  
                        </div>
                    </div>
                    <div className="data-body row">
                        <div className="col-12 col-md-7 col-lg-6">
                            <div className="px-1">
                                {dataDisplay && dataDisplay.blocks.map((item, index) => (
                                    <div key={index} className="CollectionMainInfoMajorArea">
                                        {item.alias==="" ? "" : 
                                            <div className="CollectionMainInfoAreaPageVer">
                                                <div className="MovieRowTitle" >{item.alias}</div>
                                            </div>}
                                        {item.data.map((obj, i)=>(
                                            <div key={i} className="CollectionMainInfoAreaPageVer">
                                                <div className="CollectionMainInfoRow" style={{display:'flex'}}>
                                                    <div className="CollectionMainInfoRowTitlePageVer" >{Object.keys(obj)[0]}</div>
                                                    <div className="CollectionMainInfoRowContentPageVer" >  
                                                        <CollectionMaininfoPageCell>
                                                        {type==="film" && (Object.keys(obj)[0]==="職員表" || Object.keys(obj)[0]==="演員表") ? (
                                                            filmJSONlist(Object.keys(obj)[0], Object.values(obj)[0]) 
                                                        ) : (                             
                                                            <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(Object.values(obj)[0]) }} />
                                                        )}
                                                        </CollectionMaininfoPageCell>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="data-img col-12 col-md-5 col-lg-4 ">
                            {createMedia()}
                            <aside>
                                <span>典藏單位</span>
                                <p>國家電影及視聽文化中心</p>
                            </aside>
                            <aside>                            
                                <p style={{marginBottom:'2px',color:'black',fontWeight:'bolder'}}>
                                    藏品能否租借，本中心需視藏品狀態、有無權限等因素而評估，若需取用請填寫
                                    <a href="https://www.tfai.org.tw/downloads/rent">資料借出使用申請單</a>
                                    ，向本中心提出申請。
                                </p>
                            </aside>
                        </div>
                    </div>
                </div>
            </div>            
            <Footer />
        </div>
    </>)
};

export default Detail;